$.lui("comp",".comp_newsletter",function (selector) {
    const formWrap = selector.find('.wrp_comp_form')
    const btnWrap = selector.find('.wrp_comp_button')
    selector.one("click","[data-open-form]",function () {
        btnWrap.slideUp()
        formWrap.slideDown()
    })
});
